import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import PropTypes from 'prop-types';
import Icon from '../Icon';

import i18n from '../../../src/i18n/translate';


export default class AvailableLanguagesField extends Component {
  static propTypes = {
    activeLanguage: PropTypes.string,
    languages: PropTypes.arrayOf(PropTypes.object),
    defaultLanguage: PropTypes.string,
    isNewRecord: PropTypes.bool,
    onLanguageChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    languages: [{ en: 'english' }]
  };

  constructor(props) {
    super(props);
  }

  render() {
    let { activeLanguage, defaultLanguage, languages } = this.props;
    if (this.props.isNewRecord && this.props.defaultLanguage) {
      languages = languages.filter(language => Object.keys(language)[0] === defaultLanguage);
    }

    return (
      <FormGroup className="translate-rail">
        <ControlLabel className="translate-label">{i18n.t('Available Languages')} <span className="tooltip-container"><OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{i18n.t('Select a language to see that version of your content')}</Tooltip>}><span><Icon iconType="help-outline" /></span></OverlayTrigger></span></ControlLabel>
        <ul>
          {
            languages.map((language, i) => {
              const locale = Object.keys(language)[0];
              return (
                <li key={i} onClick={() => this.props.onLanguageChange(language)} className={`${(activeLanguage === locale.toLowerCase() ? 'active ' : '')} ${locale} translate-language`}>
                  {language[locale]} {defaultLanguage === locale ? i18n.t('(default)') : null}
                </li>
              );
            })
          }
        </ul>
      </FormGroup>
    )
  }
}
